import Home from './components/Pages/Home.vue';
import Login from "./components/Pages/Login.vue";
import ExpenseIndex from './components/ExpensesScan/Index.vue';
import ExpenseView from './components/ExpensesScan/View.vue';
import Scan from "./components/ExpensesScan/Scan.vue";
import Profile from "./components/Pages/Profile.vue";
import LeavesNew from "./components/Leaves/New.vue";
import LeavesValidation from "./components/Leaves/Validation.vue";
import LeavesIndex from "./components/Leaves/Index.vue";
import {createRouter, createWebHistory} from "vue-router";
import store from './store.js'

async function checkAuth(to) {
	if(!store.dispatch('checkAuth')) {
		return {
			name: 'login',
		}
	}
}

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{path: "/", name: 'home', component: Home,},
		{path: "/scan/:id?", name: 'scan', component: Scan,},
		{path: "/login", name: 'login', component: Login},
		{path: "/expenses", name: 'expenses', component: ExpenseIndex},
		{path: "/expenses/view/:id", name: 'expensesview', component: ExpenseView},
		{path: "/leaves/new", name: 'leavesnew', component: LeavesNew,},
		{path: "/leaves/validation", name: 'leavesvalidation', component: LeavesValidation,},
		{path: "/leaves", name: 'leaves', component: LeavesIndex,},
		{path: "/profile", name: 'profile', component: Profile,},
	]
});

router.beforeEach(async (to, from) => {
	const loginStatus = await store.dispatch('checkAuth');
	//non connecté
	if(!loginStatus && to.name !== 'login') {
		return {
			name: 'login',
		}
	}

	//connecté
	if(loginStatus && to.name === 'login') {
		return {
			name: 'home',
		}
	}
})

export default router;